/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Company_AdvertisingInputs */

const de_commons_footer_company_advertising = /** @type {(inputs: Commons_Footer_Company_AdvertisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werbung`)
};

/** @type {(inputs: Commons_Footer_Company_AdvertisingInputs) => LocalizedString} */
const en_commons_footer_company_advertising = de_commons_footer_company_advertising;

/**

* @param {Commons_Footer_Company_AdvertisingInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_company_advertising = /** @type {((inputs?: Commons_Footer_Company_AdvertisingInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Company_AdvertisingInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_company_advertising(inputs)
	return en_commons_footer_company_advertising(inputs)
});